import { useState } from "react";
import "./iconAnimation.css";
import { AiOutlineExclamationCircle } from "react-icons/ai";
const IconAnimation = () => {
	const [isHovering, setIsHovering] = useState(false);

	const handleMouseOver = () => {
		setIsHovering(true);
	};

	const handleMouseOut = () => {
		setIsHovering(false);
	};
	return (
		<div className='box-icon-animation'>
			<div
				className='box-icon-text-animation'
				onMouseOver={handleMouseOver}
				onMouseOut={handleMouseOut}
			>
				<AiOutlineExclamationCircle className='icon-animation' />
			</div>
			{isHovering && (
				<div className='buble-explain'>
					<p className='text-color-bubble'>
						Ver definición en el Glosario <br /> al final del
						informe.
					</p>
				</div>
			)}
		</div>
	);
};

export default IconAnimation;